import { render, staticRenderFns } from "./JwTVModal.vue?vue&type=template&id=654ca4e7&scoped=true"
import script from "./JwTVModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./JwTVModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./JwTVModal.vue?vue&type=style&index=0&id=654ca4e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ca4e7",
  null
  
)

export default component.exports